// supabase.service.ts
import { Injectable } from '@angular/core';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { BehaviorSubject } from 'rxjs';

const supabaseUrl = 'https://ldtiqtwoalwkalbhqkzp.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxkdGlxdHdvYWx3a2FsYmhxa3pwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY1OTk1MjIsImV4cCI6MjA2MjE3NTUyMn0.ZOTG2AAfjo8GZq5RVtKj6WMSVYN-xp4jxeYwECVre9M';

@Injectable({
	providedIn: 'root',
})
export class SupabaseService {
	private supabase: SupabaseClient;

	private currentUserSubject = new BehaviorSubject<any>(null);
	currentUser$ = this.currentUserSubject.asObservable();

	constructor() {
		this.supabase = createClient(supabaseUrl, supabaseKey, {
			auth: {
			  autoRefreshToken: false, // 關掉自動刷新
			  persistSession: true    // 關掉 localStorage 儲存
			}
		});
		// this.init();
	}

	// init() {
	// 	this.supabase.auth.onAuthStateChange((_event, session) => {
	// 		if (session?.user) {
	// 			console.log('already', session);
	// 			this.currentUserSubject.next(session.user);
	// 		} else {
	// 			this.currentUserSubject.next(null);
	// 			console.log('no', session);
	// 		}
	// 	});
	// }
	// ----------------------------------GroupBreaks(Start)--------------------------------------------------
	// 取得所有上架中的商品（含團拆、周邊商品，商品列表頁依 type 欄位自行分區塊）
	getGroupBreaks() {
		return this.supabase
			.from('Products')
			.select('*')
			.eq('isActive', true)
			.order('sortOrder', { ascending: true });
	}

	// 依 productId (如 'BAS-048') 取得單一團拆商品資訊（購買頁用）
	getGroupBreakByProductId(productId: string) {
		return this.supabase
			.from('Products')
			.select('*')
			.eq('productId', productId)
			.single();
	}
	// ----------------------------------GroupBreaks(End)--------------------------------------------------
	// ----------------------------------MagneticCase(Start)--------------------------------------------------
	// 取得磁鐵殼所有規格（類型/尺寸/顏色）的價格與庫存
	getMagneticCaseVariants() {
		return this.supabase.from('MagneticCaseVariants').select('*');
	}

	// 送出磁鐵殼訂單（可包含多筆規格明細），RPC 內部會檢查庫存、防止超賣，價格也是後端現查現用
	submitMagneticCaseOrder(orderId: string, items: { variantId: number; quantity: number }[], buyer: any) {
		return this.supabase.rpc('submit_magnetic_case_order', {
			p_order_id: orderId,
			p_items: items,
			p_buyer: buyer
		});
	}
	// ----------------------------------MagneticCase(End)--------------------------------------------------
	// ----------------------------------Form(Start)--------------------------------------------------
	getTeams(table) {
		return this.supabase.from(table).select('*').or('isLock.eq.false,isLock.is.null').order('id', { ascending: true });
	}

	getTeamsById(ids, table) {
		return this.supabase.from(table).select('*').in('id', ids);;
	}

	updateTeamInfo(ids: any, param, table) {
		return this.supabase
		.from(table)
		.update(param)
		.in('id', ids)
		.select();
	}

	// 檢查折扣代碼是否存在且尚未被使用
	checkDiscountCode(discountCode) {
		return this.supabase.from('Discount_Code').select('*').eq('discountCode', discountCode).eq('isUsed', false);
	}

	// 將使用過之折扣代碼註銷為已使用
	updateDiscountCodeToIsUsed(discountCode) {
		return this.supabase
		.from('Discount_Code')
		.update({ isUsed: true })
		.eq('discountCode', discountCode);
	}
	// ----------------------------------Form(End)--------------------------------------------------
	// ----------------------------------MyAccount(Start)--------------------------------------------------
	// 更新個人資料
	updateProfile(id, params) {
		return this.supabase
		.from('Profiles')
		.update(params)
		.eq('id', id)
		.select('id');
	}

	// 取得個人折扣代碼
	getDiscountCode(id) {
		return this.supabase.from('Discount_Code').select('*').eq('personId', id).or('isUsed.eq.false,isUsed.is.null');
		// return this.supabase.from('Discount_Code').select('*').eq('personId', id);
	}
	// ----------------------------------MyAccount(End)--------------------------------------------------

	// ----------------------------------Sign(Start)--------------------------------------------------
	// Register
	signUp(email: string, password: string) {
		return this.supabase.auth.signUp({
			email: email,
			password: password,
			options: {
				emailRedirectTo: 'https://bigaunt666.github.io/bigaunt/signUpCallback',
			},
		});
	}

	// 建立使用者
	createUser(userInfo) {
		return this.supabase
		.from('Profiles')
		.insert(userInfo);
	}

	// 登入
	signIn(email: string, password: string) {
		return this.supabase.auth.signInWithPassword({
			email: email,
			password: password
		});
	}

	// 登出
	logOut(email: string, password: string) {
		return this.supabase.auth.signOut();
	}

	// 取得登入狀態
	getSession() {
		return this.supabase.auth.getSession();
	}

	// 取得個人資料
	getProfile(id) {
		return this.supabase.from('Profiles').select('*').eq('id', id);
	}
	// ----------------------------------Sign(End)--------------------------------------------------

	// public lockTeams(
	// 	tableName,
	// 	selectedTeamIds: number[],
	// 	buyerInfo
	// ): Observable<boolean> {
	// 	const payload = {
	// 		p_table_name: tableName,
	// 		selected_team_ids: selectedTeamIds,
	// 		p_buyer_data: buyerInfo
	// 	};

	// 	return from(
	// 		this.supabase.rpc(
	// 			'lock_teams',
	// 			payload
	// 		)
	// 	).pipe(
	// 		map((res: any) => {
	// 			if (res.error) {
	// 				throw res.error;
	// 			}
	// 			return res.data as boolean;
	// 		})
	// 	);
	// }
	// lock teams（只做 RPC）
	lockTeams(
		p_table_name: string,
		selected_team_ids: number[],
		p_buyer_data: any
	) {
		return this.supabase.rpc('lock_teams', {
			p_table_name,
			selected_team_ids,
			p_buyer_data,
		});
	}
	// getCurrentUser() {
	// 	return this.currentUserSubject.value;
	// }
}
